import { createContext } from "react";

import { IContentModuleProps } from "../services/elevar/interfaces";

export const ContentModuleContext = createContext<Omit<
  IContentModuleProps,
  "modulePosition"
> | null>(null);
